import axios from "../../util/axios";

export default {
    /** 客户分类 */
    queryCategory: () => axios.get({url: "/erp/customerErp/queryCategory",}),
    /** 客户分类 */
    queryErpCustomerList: (data) => axios.get({url: "/erp/customerErp/queryErpCustomerList", data}),
    /** xbot客户列表 */
    queryXbotCustomerList: (data) => axios.get({url: "/wx/common/xbot/queryXbotCustomerList", data}),
    /**设置xbot的客户*/
    setXbotId: (data) => axios.get({url: "/erp/customerErp/setXbotId", data})
}